import React from "react";

import { motion } from "framer-motion";

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, staggerChildren: 0.2 }
};

export default function Home() {

  return (
    <>
      <motion.div 
        id="home" 
        className="hero min-h-[60vh] flex items-center pt-48 pb-24"
        initial="initial"
        animate="animate"
        variants={fadeIn}
      >
        <div className="container mx-auto px-6 flex flex-col md:flex-row items-center justify-around">
          <div>
            <h1 className="text-4xl md:text-6xl font-bold mb-4">Henry Shih</h1>
            <h2 className="text-2xl md:text-3xl text-neutral-600 mb-6">Software Engineer</h2>
            <p className="text-xl text-neutral-500 max-w-2xl">
              Building user-focused web applications with modern technologies.
            </p>
            <div className="flex md:justify-start justify-center gap-4 mt-8">
              <a 
                href="/files/Henry-Shih-Resume-SWE.pdf"
                download
                target="_blank"
                className="inline-flex items-center px-6 py-3 bg-primary-color text-white rounded-lg hover:bg-neutral-800 transition-colors duration-300"
              >
                View Resume
              </a>
            </div>
          </div>
          
          <motion.div 
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="mt-8 md:mt-0 relative group"
          >
            <img 
              src="/images/hen-profile.png" 
              alt="Henry Shih" 
              className="w-[300px] h-[300px] md:w-[360px] md:h-[360px] object-cover rounded-full shadow-lg 
                       transition-all duration-300 ease-in-out
                       group-hover:scale-105 group-hover:shadow-2xl"
              width={600}
              height={600}
              style={{
                objectFit: 'cover',
                imageRendering: '-webkit-optimize-contrast',
              }}
            />
            <div className="absolute inset-0 rounded-full 
                          bg-primary-color opacity-0 
                          group-hover:opacity-10 
                          transition-opacity duration-300 ease-in-out" 
            />
          </motion.div>
        </div>
      </motion.div>

      {/* <section className="about bg-white py-20">
        <div className="container mx-auto px-6">
          <motion.div 
            className="max-w-3xl mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6">About Me</h2>
            <p className="text-lg text-neutral-600 leading-relaxed mb-6">
              As a Software Engineer with a unique background in Physical Therapy, I bring a distinctive perspective to problem-solving and user experience. My transition from healthcare to technology demonstrates my adaptability and commitment to continuous learning.
            </p>
            <div className="flex justify-center gap-4 mt-8">
              <a 
                href="/files/Henry-Shih-Resume.pdf"
                download
                target="_blank"
                className="inline-flex items-center px-6 py-3 bg-primary-color text-white rounded-lg hover:bg-neutral-800 transition-colors duration-300"
              >
                View Resume
              </a>
            </div>
          </motion.div>
        </div>
      </section> */}

      <section className="skills bg-neutral-50 py-20">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12">Technical Skills</h2>
          <motion.div 
            className="grid md:grid-cols-3 gap-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ staggerChildren: 0.2 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Frontend</h3>
              <div className="flex flex-wrap gap-2">
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">JavaScript</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">React</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">Tailwind</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">HTML</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">CSS</span>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Backend</h3>
              <div className="flex flex-wrap gap-2">
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">Python</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">Java</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">Node.js</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">MongoDB</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">SQL</span>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Certifications</h3>
              <div className="flex flex-wrap gap-2">
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">AWS Cloud Practitioner</span>
                <span className="px-4 py-2 bg-white rounded-lg shadow-sm">ITIL4 Foundation</span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <section id="education" className="py-10">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12">Education</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Western Governors University</h3>
              <p className="text-neutral-600">Bachelor of Science in Software Engineering</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">University of Texas Medical Branch</h3>
              <p className="text-neutral-600">Doctorate of Physical Therapy</p>
            </div>
          </div>
        </div>
      </section>

      <section id="projects" className="projects py-20 bg-neutral-50">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold mb-12">Featured Projects</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <motion.div 
              className="project-card bg-white p-6 border border-neutral-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-center items-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="w-full mb-4">
                <img 
                  src="/images/projects/sports-stack-project.png" 
                  alt="Sports Stack" 
                  className="w-full h-[240px] object-cover rounded-lg lg:h-full"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-bold">Sports Stack</h3>
                <p className="text-neutral-600">
                  A web application that providing users with latest sports news and information. 
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">React</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">Node.js</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">Python</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">MongoDB</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">Firebase</span>
        </div>
                <div className="flex gap-4 pt-2">
                  <a 
                    href="https://sports-stack.web.app/all/1" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-primary-color text-white rounded-lg hover:bg-neutral-800 hover:text-white transition-colors duration-300"
                  >
                    Live Demo
                  </a>
                  <a 
                    href="https://github.com/henry-shih4/sportsstack" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 border border-primary-color text-neutral-800 rounded-lg hover:bg-neutral-800 hover:text-white transition-colors duration-300"
                  >
                    GitHub
                  </a>
                </div>
                <div className="border-t border-neutral-200 pt-4">
                  <h4 className="font-semibold mb-2">Key Features:</h4>
                  <ul className="list-disc list-inside text-neutral-600 space-y-1">
                    <li>Implemented real-time web scraping with Python</li>
                    <li>Built responsive UI with Tailwind CSS</li>
                    <li>Integrated AUTH0 for user authentication</li>
                    <li>Implemented pagination for efficient data retrieval</li>
                    <li>Integrated MongoDB for database storage</li>
                  </ul>
                </div>
                <div className="border-t border-neutral-200 pt-4">
                  <h4 className="font-semibold mb-2">Technical Challenges Solved:</h4>
                  <p className="text-neutral-600">
                    Optimized performance by implementing server-side pagination to handle large datasets efficiently, reducing initial load time 3 seconds
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div 
              className="project-card bg-white p-6 border border-neutral-200 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col justify-center items-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <div className="w-full mb-4">
                <img 
                  src="/images/projects/pokedex-app.png" 
                  alt="Pokemon Portal" 
                  className="w-full h-[240px] object-cover rounded-lg lg:h-full"
                />
              </div>
              <div className="space-y-4">
                <h3 className="text-2xl font-bold">Pokemon Portal</h3>
                <p className="text-neutral-600 ">
                  A web application that allows users to view and interact with data from the PokeAPI.
                </p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">React</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">API</span>
                  <span className="px-3 py-1 bg-neutral-100 rounded-full text-sm">CSS Styled Components</span>
                </div>
                <div className="flex gap-4 pt-2">
                  <a 
                    href="https://pokemon-portal.netlify.app/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-primary-color text-white rounded-lg hover:bg-neutral-800 hover:text-white transition-colors duration-300"
                  >
                    Live Demo
                  </a>
                  <a 
                    href="https://github.com/henry-shih4/pokemon-project" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 border border-primary-color text-neutral-800 rounded-lg hover:bg-neutral-800 hover:text-white transition-colors duration-300"
                  >
                    GitHub
                  </a>
                </div>
                <div className="border-t border-neutral-200 pt-4">
                  <h4 className="font-semibold mb-2">Key Features:</h4>
                  <ul className="list-disc list-inside text-neutral-600 space-y-1">
                    <li>Formatting and Caching data for state management</li>
                    <li>Built responsive UI with Styled Components</li>
                    <li>Fetching data from third-party APIs</li>
                  </ul>
                </div>
                <div className="border-t border-neutral-200 pt-4">
                  <h4 className="font-semibold mb-2">Technical Challenges Solved:</h4>
                  <p className="text-neutral-600">
                    Optimized performance by implementing data caching, reducing API calls by 60%
                  </p>
                </div>

              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-4xl mx-auto"
          >
            <h2 className="text-3xl font-bold mb-12 text-center">About Me</h2>
            
            {/* Professional Introduction */}
            <div className="text-center mb-16">
              <p className="text-lg text-neutral-600 leading-relaxed">
                As a Software Engineer with a unique background in Physical Therapy, I bring a distinctive perspective to problem-solving and user experience. My transition from healthcare to technology demonstrates my adaptability and commitment to continuous learning.
              </p>
            </div>

            {/* Interests Cards */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <motion.div 
                className="p-6 bg-neutral-50 rounded-lg hover:shadow-lg transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <div className="w-12 h-12 mb-4 mx-auto">
                  <img 
                    src="/images/svg-icons/basketball.svg" 
                    alt="Basketball" 
                    className="w-full h-full"
                  />
                </div>
                <h3 className="text-xl font-bold mb-3 text-center">Sports</h3>
                <p className="text-neutral-600 text-center">
                  Sports fan and fitness advocate, bringing the same dedication to both the game and code.
                </p>
              </motion.div>

              <motion.div 
                className="p-6 bg-neutral-50 rounded-lg hover:shadow-lg transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <div className="w-12 h-12 mb-4 mx-auto">
                  <img 
                    src="/images/svg-icons/cat-icon.svg" 
                    alt="Pets" 
                    className="w-full h-full"
                  />
                </div>
                <h3 className="text-xl font-bold mb-3 text-center">Animal Lover</h3>
                <p className="text-neutral-600 text-center">
                  Proud pet parent, advocating for animal welfare and the joy they bring to our lives.
                </p>
              </motion.div>

              <motion.div 
                className="p-6 bg-neutral-50 rounded-lg hover:shadow-lg transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <div className="w-12 h-12 mb-4 mx-auto">
                  <img 
                    src="/images/svg-icons/movie-icon.svg" 
                    alt="Movies" 
                    className="w-full h-full"
                  />
                </div>
                <h3 className="text-xl font-bold mb-3 text-center">Film & Media</h3>
                <p className="text-neutral-600 text-center">
                  Cinema enthusiast, drawing creative inspiration from storytelling and visual arts.
                </p>
              </motion.div>

              <motion.div 
                className="p-6 bg-neutral-50 rounded-lg hover:shadow-lg transition-all duration-300"
                whileHover={{ y: -5 }}
              >
                <div className="w-12 h-12 mb-4 mx-auto">
                  <img 
                    src="/images/svg-icons/watch-icon.svg" 
                    alt="Health" 
                    className="w-full h-full"
                  />
                </div>
                <h3 className="text-xl font-bold mb-3 text-center">Health & Wellness</h3>
                <p className="text-neutral-600 text-center">
                  Former PT bringing healthcare insights to tech solutions and maintaining work-life balance.
                </p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      <section id="contact" className="contact py-20 bg-primary-color text-neutral-50">
        <div className="container mx-auto px-6">
          <motion.div 
            className="max-w-2xl mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-8">Let's Connect</h2>
            <p className="text-lg mb-8">
              I'm currently open to new opportunities and would love to hear from you!
            </p>
            <div className="flex justify-center gap-6">
              <a 
                href="mailto:henryshih4@gmail.com" 
                className="flex items-center gap-2 hover:text-neutral-800 transition-colors"
              >
                <img className="w-6 h-6" src="/images/svg-icons/email.svg" alt="Email"/>
                Email
              </a>
              <a 
                href="https://www.linkedin.com/in/henry-shih/" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-neutral-800 transition-colors"
              >
                <img className="w-6 h-6" src="/images/svg-icons/linkedin.svg" alt="LinkedIn"/>
                LinkedIn
              </a>
              <a 
                href="https://github.com/henry-shih4" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-neutral-800 transition-colors"
              >
                <img className="w-6 h-6" src="/images/svg-icons/github.svg" alt="GitHub"/>
                GitHub
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
